import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AboutImage, AboutStyles, AboutType } from "./about.styles";
import Liner from "../../components/Liner";
import { RoundedButton } from "../../components/Button/button.styles";
import { OpredelitelContext } from "../../context";
import { optimizedImageUrl } from "../../helpers";
import List from "./list";

const getImageUrl = (imageName) => optimizedImageUrl("md", imageName);

const About = () => {
  const { paperType, refMap, papers } = useContext(OpredelitelContext);
  const [isListOpen, setListOpen] = useState(false);
  const [failedImage, setFailedImage] = useState(null);
  const navigate = useNavigate();

  const paper = papers.find((item) => item.id === paperType);

  const title = paper?.name?.trim();
  const lists = paper?.lists?.trim();
  const original = paper?.original?.trim();
  const dbText = paper?.text?.trim() || "";

  const dbImageUrl = getImageUrl(original);
  const imageUrl = dbImageUrl;

  useEffect(() => {
    setFailedImage(null);
  }, [dbImageUrl]);

  const handleImageError = () => {
    if (failedImage !== dbImageUrl) setFailedImage(dbImageUrl);
  };

  const handleLinkClick = (event) => {
    const {
      target: { tagName, parentElement, href },
    } = event;

    if (tagName === "A" || parentElement?.tagName === "A") {
      const elHref = tagName === "A" ? href : parentElement.href;
      event.preventDefault();

      const lastSegment = +elHref.split("/").filter(Boolean).pop();
      navigate(`/opredelitel/${lastSegment}`);
    }
  };

  return (
    <AboutStyles>
      <Liner linerHeight={100} borderColor="#000000" />
      <div>
        <AboutImage src={imageUrl} alt={title} onError={handleImageError} />
      </div>
      <AboutType>
        <h3>{title}</h3>
        <div>
          {lists && (
            <>
              <em>({lists})</em>
              <br />
              <br />
            </>
          )}
          <div
            className="about-text"
            onClick={handleLinkClick}
            dangerouslySetInnerHTML={{ __html: dbText }}
          />
        </div>
      </AboutType>
      <RoundedButton
        ref={(el) => (refMap.current["alphabet_navigator"] = el)}
        onClick={() => setListOpen(!isListOpen)}
      >
        Алфавитный указатель узоров
      </RoundedButton>
      {isListOpen && (
        <List itemsPerColumn={[2, 3].includes(paperType) ? 4 : 9} />
      )}
    </AboutStyles>
  );
};

export default About;
